export const TEXT_BUTTON = 'textButton';
export const IMAGE_HEADER = 'imageHeader';
export const IMAGE_MENU_HEADER = 'imageMenuHeader';
export const IMAGE_MENU_HORIZONTAL = 'imageMenuHorizontal';
export const IMAGE = 'image';
export const BUTTON = 'button';
export const TEXT_BUTTON_HORIZONTAL = 'textButtonHorizontal';
export const IMAGE_TEXT = 'imageText';
export const HERO_OVERLAY_IMAGE = 'heroOverlayImage';
export const HERO_IMAGE = 'heroImage';
export const STORE_PRODUCT_ONE = 'storeProductOne';
export const STORE_PRODUCT_TWO = 'storeProductTwo';
export const TESTIMONIAL_DOUBLE = 'testimonialDouble';
export const TESTIMONIAL_SINGLE = 'testimonialSingle';
export const COUPON_CODE = 'couponCode';
export const COUPON_CODE_BLOCK = 'couponCodeBlock';
export const SEPARATOR = 'separator';
export const PARAGRAPH_ONE = 'paragraphOne';
export const PARAGRAPH_TWO = 'paragraphTwo';
export const HEADING_ONE = 'headingOne';
export const VIDEO = 'video';
export const VIDEO_TEXT = 'videoText';
export const FOOTER_ONE = 'footerOne';
export const FOOTER_TWO = 'footerTwo';
export const FOOTER_THREE = 'footerThree';
export const UNSUBSCRIBE = 'unsubscribe';
export const COUNTDOWN_TIMER = 'countdownTimer';
export const SIMPLE = 'simple';
export const WL_LOGO = 'wlLogo';
export const ORDER_DETAILS = 'orderDetails';
export const CART_DETAILS = 'cartDetails';
export const BOOKING_ANSWERS = 'bookingAnswers';
export const DOWNLOAD = 'download';
